<template>
    <div class="pattern">
        <section class="success" id="success">
            <div class="container vld-parent">
                <loading :active.sync="isLoading" :background-color="'#000'" :color="'#ecd19a'" :opacity="0.7"></loading>
                <div class="row">
                    <h2>Welcome to Newhaven!</h2>
                </div>
                <p class="section-description">Thank you for purchasing Embers Adrift!</p>

                <div v-if="!surveyCompleted" class="center-block" style="text-align: center; margin-top: 16px;">
                    <div class="formblock">
                        <div>How did you hear about Embers Adrift?</div>
                        <b-form-select v-model="selected" :options="options"></b-form-select>
                        <b-form-input v-if="selected && selected == 'creator'" v-model="creator" size="sm" id="creator" placeholder="Creator"></b-form-input>
                        <button v-if="selected" @click="submitSummary()" class="outline-btn" style="width: 180px; margin-top: 16px;">Submit</button>
                    </div>
                </div>

                <p class="section-description">Visit the forums to keep in touch with the community!</p>
                <div class="center-block">
                    <p class="norm">Visit your account page to download the game client and get ready to Ignite your Adventure!</p>
                </div>
                
                <div class="notice">If you purchased Game Time, you will find your keys at the bottom of your account page.</div>
                <div class="notice">You can use your own keys for yourself if you like by placing it in the "Activate Key" box found on your account page</div>

                <div class="center-button" style="margin-top: 2em;">
                    <router-link to="Account" v-slot="{ href, navigate }" >
                        <a xmlns="http://www.w3.org/1999/xhtml" class="button-game" :href="href" @click="navigate">
                            <span class="button-game-bg-left"></span>
                            <span class="button-game-bg-mid">
                                <span>My Account</span>
                            </span>
                            <span class="button-game-bg-right"></span>
                        </a>
                    </router-link>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'SuccessComponent',
        components: { Loading },
        data() {
            return { 
                isLoading: false,
                surveyCompleted: false,
                order_id: this.$route.query.order_id,
                selected: null,
                creator: null,
                options: [
                    { value: null, text: 'Please select an option' },
                    { value: 'youtube', text: 'YouTube Trailer' },
                    { value: 'socialmedia', text: 'On social media' },
                    { value: 'article', text: 'An article ' },
                    { value: 'ad', text: 'An ad' },
                    { value: 'creator', text: 'A creator' }
                ]
            }
        },
        methods: {
            submitSummary() {
                this.isLoading = true;
                this.axios.post(this.$config.api_url + "/My/Survey?heardFrom=" + this.selected + "&creator=" + this.creator, null, { withCredentials: true }).then((response) => {
                    this.account = response.data;
                    this.$toast.success('Thank you!');
                    this.surveyCompleted = true;
                    this.isLoading = false;
                }).catch(() => {
                    this.$toast.error('Error Submitting Survey, Please Try again');
                    this.isLoading = false;
                });
            }
        }
    }
</script> 